import {equals, isNotNil} from 'ramda';

import {CampaignFormValues} from '../schemas/campaignFormSchema';

type RepublishRelevantValues = Partial<
  Pick<
    CampaignFormValues,
    'watermarkId' | 'warrantyProgramId' | 'promoPhotos' | 'keepExistingPromoPhotos' | 'discount'
  >
>;

const getRelevantRepublishValues = (values: RepublishRelevantValues) => ({
  watermarkId: values.watermarkId ?? null,
  warrantyProgramId: values.warrantyProgramId ?? null,
  promoPhotos: values.promoPhotos ?? [],
  keepExistingPromoPhotos: values.keepExistingPromoPhotos ?? false,
  discount:
    isNotNil(values.discount?.type) && isNotNil(values.discount?.amount)
      ? {type: values.discount.type, amount: values.discount.amount}
      : null,
});

export const hasChangedRelevantRepublishValues = (
  values: RepublishRelevantValues,
  baselineValues: RepublishRelevantValues
) => !equals(getRelevantRepublishValues(values), getRelevantRepublishValues(baselineValues));
